import { Box, Stack, Typography } from "@mui/material";
import TestimonialCard from "./TestimonialCard";

interface Testimonial {
  name: string;
  role: string;
  quote: string;
}

interface TestimonialsSectionProps {
  testimonials: Testimonial[];
}

const TestimonialsSection = ({ testimonials }: TestimonialsSectionProps) => {
  return (
    <Box
      sx={{
        py: { xs: "48px", md: "72px" },
        px: { xs: "24px", md: "80px" },
        maxWidth: "1152px",
        mx: "auto",
      }}
    >
      <Stack spacing={1} mb={{ xs: 4, md: 6 }}>
        <Typography
          sx={{
            fontFamily: "Mulish",
            fontWeight: 700,
            fontSize: { xs: "32px", md: "40px" },
            color: "#1a1a1a",
          }}
        >
          Testimonials
        </Typography>
        <Typography
          sx={{
            fontFamily: "Mulish",
            fontWeight: 400,
            fontSize: { xs: "15px", md: "17px" },
            color: "#737373",
            lineHeight: 1.7,
          }}
        >
          For over two decades, Muzukuru has been a trusted name in funeral
          services, providing compassionate care to families across Zimbabwe.
        </Typography>
      </Stack>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "1fr 1fr 1fr" },
          gap: { xs: 2.5, md: 3 },
        }}
      >
        {testimonials.map((testimonial, index) => (
          <TestimonialCard
            key={index}
            name={testimonial.name}
            role={testimonial.role}
            quote={testimonial.quote}
            hasBorder={index === 1}
          />
        ))}
      </Box>
    </Box>
  );
};

export default TestimonialsSection;
